import { Badge } from 'primereact/badge';
import { ExtractionStatus } from '~/api/def/endpoints/document/documentsEndpoint';
import { Spinner } from '~/components/ui/common/Spinner';

export function ExtractionStatusCellAg(props: { value: ExtractionStatus }) {
  switch (props.value) {
    /* Tooltips defined on the table level*/
    case null:
      return (
        // <Tooltip title="Extraction not started">
        <div className="h-full flex justify-content-center	align-items-center">
          <Badge severity="info" />
        </div>
        // </Tooltip>
      );
    case 'fail':
      return (
        // <Tooltip title="Extraction Error">
        <div className="h-full flex justify-content-center	align-items-center">
          <Badge severity="danger" />
        </div>
        // </Tooltip>
      );
    case 'pending':
      return (
        // <Tooltip title="Extraction Pending">
        <div className="h-full flex justify-content-center	align-items-center">
          <Spinner size={16} />
        </div>
        // </Tooltip>
      );
    case 'success':
      return (
        // <Tooltip title="Extraction Complete">
        <div className="h-full flex justify-content-center	align-items-center">
          <Badge severity="success" />
          {/*<Badge status="success" />*/}
        </div>
        // </Tooltip>
      );
    case 'started':
      return (
        // <Tooltip title="Extraction Running">
        <div className="h-full flex justify-content-center	align-items-center">
          <Spinner size={16} />
        </div>
        // </Tooltip>
      );
  }
  // assertNever(props.extractionStatus);
}
